import React from "react";
import {
  Box,
  Heading,
  Input,
  Divider,
  Text,
  Tooltip,
} from "@chakra-ui/react";

const SectionBox = ({ title, children }) => (
  <Box
    mt={6}
    p={4}
    border="2px solid"
    borderColor="gray.600"
    borderRadius="md"
    bg="white"
    boxShadow="md"
    textAlign="left"
  >
    <Heading size="md" mb={2}>{title}</Heading>
    <Divider mb={4} />
    {children}
  </Box>
);

const getNestedValue = (obj, path) => {
  return path.split(".").reduce((acc, part) => acc?.[part], obj);
};

const getBorderColor = (originalData, name, value) => {
  const original = getNestedValue(originalData, name);
  const hasOriginal = original !== undefined && original !== null && original !== "";
  const hasValue = value !== undefined && value !== null && value !== "";

  if (!hasOriginal && hasValue) return "2px solid green"; // Added
  if (hasOriginal && !hasValue) return "2px solid red";   // Deleted
  if (hasOriginal && hasValue && original !== value) return "2px solid blue"; // Changed
  return "1px solid #E2E8F0"; // Unchanged
};

const getTooltipLabel = (originalData, name, value) => {
  const original = getNestedValue(originalData, name);
  const hasOriginal = original !== undefined && original !== null && original !== "";
  const hasValue = value !== undefined && value !== null && value !== "";

  if (!hasOriginal && hasValue) return "Added new value";
  if (hasOriginal && !hasValue) return `Deleted previous value: ${original}`;
  if (hasOriginal && hasValue && original !== value) return `Changed from: ${original}`;
  return "";
};

const renderInput = (label, name, value, onChange, originalData) => (
  <Box mb={3}>
    <Text fontSize="sm" mb={1}>{label}</Text>
    <Tooltip label={getTooltipLabel(originalData, name, value)} isDisabled={!getTooltipLabel(originalData, name, value)}>
      <Input
        value={value || ""}
        onChange={onChange}
        border={getBorderColor(originalData, name, value)}
      />
    </Tooltip>
  </Box>
);

const PrimaryContactSection = ({
  primaryContactName,
  setPrimaryContactName,
  primaryContactEmail,
  setPrimaryContactEmail,
  primaryContactPhone,
  setPrimaryContactPhone,
  originalData = {},
}) => {
  return (
    <SectionBox title="Primary Contact">
      {renderInput("Full Name", "primaryContactName", primaryContactName, (e) => setPrimaryContactName(e.target.value), originalData)}
      {renderInput("Email Address", "primaryContactEmail", primaryContactEmail, (e) => setPrimaryContactEmail(e.target.value), originalData)}
      {renderInput("Phone Number", "primaryContactPhone", primaryContactPhone, (e) => setPrimaryContactPhone(e.target.value), originalData)}
    </SectionBox>
  );
};

export default PrimaryContactSection;
